module.exports = __webpack_public_path__ + "static/media/google7.e318dfe3.png";